export default "__VITE_ASSET__f90849c1__"